import utils from "./utils";

export default function getOfflineWebData() {
  return new Promise((resolve, reject) => {

    const appVersion = utils.getVersion();
    const isAndroid = utils.isAndroid();

    if (
      (!isAndroid && utils.SHDiffVersion(appVersion, '8.24.0')) ||
      (isAndroid && utils.SHDiffVersion(appVersion, '8.25.0'))
    ) {
      // IOS 8.24.0 开始支持离线包
      // Android 8.25.0 开始支持离线包
      window.Jockey && window.Jockey.send('getOfflinePageData', (res) => {
        if (res && res.baseConfig && res.components) {
          let { baseConfig, components } = res;
          baseConfig = typeof baseConfig === 'string' ? JSON.parse(baseConfig) : baseConfig;
          components = typeof components === 'string' ? JSON.parse(components) : components;
  
          // 设置页面标题
          document.title = baseConfig.title;
          
          // 设置页面背景色
          document.documentElement.style.backgroundColor = baseConfig.backgroundColor;
          document.body.style.backgroundColor = baseConfig.backgroundColor;
  
          // 设置全局页面基本配置
          Object.entries(baseConfig).forEach(([key, value]) => {
            if (window.hasOwnProperty(key)) {
              window[key] = value;
            }
          });
  
          // 设置全局组件配置
          window.INIT_DATA = components;

          resolve({})
  
        } else {
  
          resolve({})
        }
      });

    } else {
      
      resolve({});
    }
  })
}




// WEBPACK FOOTER //
// ./utils/getOfflineWebData.js